module.exports = __webpack_public_path__ + "static/media/Artboard10.f1eaa287.png";